import "./index.css";
import { Select } from "antd";
import React, { useMemo } from "react";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";

import type { SelectProps } from "antd/lib";

interface TypeRenFeiSelectProps extends SelectProps {}

/**
 * @name RenFeiSelect 多选下拉框
 * @description RenFei画的UI，主流UI库都不支持，这里为了后期还会用到，独立出来
 * 被选中的Item，不在Select框内，在select框下面👍
 */
const RenFeiSelect: React.FC<TypeRenFeiSelectProps> = ({
  value = [],
  options = [],
  mode = "multiple",
  showSearch = true,
  optionFilterProp = "label",
  prefix = <SearchOutlined rev={undefined} />,
  ...props
}) => {
  const MAP = useMemo(
    () => Object.fromEntries(options.map((v) => [v.value, v])),
    [options],
  );

  function onDelete<T extends React.Key>(v: T) {
    const i = value.indexOf(v);
    if (~i) {
      value.splice(i, 1);
      props.onChange([...value]);
    } else {
      props.onChange([...value, v]);
    }
  }

  return (
    <div className="renfei-select">
      <Select
        {...props}
        mode={mode}
        value={value}
        maxTagCount={0}
        prefix={prefix}
        options={options}
        showSearch={showSearch}
        optionFilterProp={optionFilterProp}
        maxTagPlaceholder={() => props.placeholder}
      />
      <div className="renfei-select-values">
        {value.map((v) => (
          <span key={v} className="renfei-select-tag">
            {MAP[v].label}
            <CloseOutlined onClick={() => onDelete(v)} rev={undefined} />
          </span>
        ))}
      </div>
    </div>
  );
};
export default RenFeiSelect;
